function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * Licensed Materials - Property of IBM
 * (c) Copyright IBM Corporation 2022, 2026. All Rights Reserved.
 *
 * Note to U.S. Government Users Restricted Rights:
 * Use, duplication or disclosure restricted by GSA ADP Schedule
 * Contract with IBM Corp.
 */
import { Button, InlineLoading } from "@carbon/react";
import { FSCloudComplianceDialog } from '@ace/otc-components-react';
import hrefs from '../../lib/shared/hrefs';
import msgs from "../../nls/setup/deploy/deploy.properties";
import Phase from "../common/model/phase";
import PropTypes from "prop-types";
import React from "react";
import '@ace/otc-components-react/src/scss/index.scss';
var DeployButtons = /*#__PURE__*/function (_React$Component) {
  function DeployButtons() {
    var _this;
    _classCallCheck(this, DeployButtons);
    _this = _callSuper(this, DeployButtons);
    _this.state = {
      showFSCloudComplianceDialog: false
    };
    return _this;
  }
  _inherits(DeployButtons, _React$Component);
  return _createClass(DeployButtons, [{
    key: "cancelHref",
    value: function cancelHref() {
      var _this$props = this.props,
        envId = _this$props.envId,
        params = _this$props.params;
      if (params) {
        if (params.app_id && params.tenant) {
          // Devex bring-your-own-code create flow
          return hrefs.createCatalog(envId, {
            id: params.app_id,
            tenant: params.tenant
          }, params);
        } else if (params['k8s-cluster-name'] && params['k8s-cluster-id'] && params['k8s-region'] && params['resource-group']) {
          // IKS flow
          return hrefs.createIksCatalog(params['k8s-cluster-name'], params['k8s-cluster-id'], params['k8s-region'], params['resource-group'], params['resource-group-id']);
        } else {
          return hrefs.createCatalog(envId);
        }
      }
      return "";
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props2 = this.props,
        allowedRegion = _this$props2.allowedRegion,
        enableCreateButton = _this$props2.enableCreateButton,
        enableToolchainCreateButton = _this$props2.enableToolchainCreateButton,
        fsCloudDialogData = _this$props2.fsCloudDialogData,
        isWizardInvalid = _this$props2.isWizardInvalid,
        locale = _this$props2.locale,
        nextIndex = _this$props2.nextIndex,
        params = _this$props2.params,
        phase = _this$props2.phase,
        prevIndex = _this$props2.prevIndex,
        showNext = _this$props2.showNext,
        showPrevious = _this$props2.showPrevious,
        showCancel = _this$props2.showCancel,
        showCreate = _this$props2.showCreate,
        stepName = _this$props2.stepName,
        wizardMode = _this$props2.wizardMode;
      var isCreateDisabled = false;
      if (wizardMode) {
        // Always enabled if user has permission to create. This allows the wizard to jump back to any invalid step
        if (enableToolchainCreateButton && allowedRegion) {
          isCreateDisabled = false;
        } else {
          isCreateDisabled = true;
        }
      } else {
        // Standard UI mode
        isCreateDisabled = !enableCreateButton || !allowedRegion || !enableToolchainCreateButton;
      }
      var continueLabel = msgs.get("label.continueButton");
      var continueKind = "tertiary";
      if (nextIndex === 1) {
        // On welcome step use Start for the continue button text
        continueLabel = msgs.get("wizard.welcome.start");
        continueKind = "primary";
      }
      return /*#__PURE__*/React.createElement(React.Fragment, null, phase !== Phase.LOADING && /*#__PURE__*/React.createElement("div", {
        className: "buttons-container"
      }, showCancel && /*#__PURE__*/React.createElement(Button, {
        kind: "secondary",
        className: "cancel-btn",
        href: this.cancelHref(),
        "data-analytics-track": "setup-cancel"
      }, msgs.get("button.cancel", locale)), wizardMode && showPrevious && /*#__PURE__*/React.createElement(Button, {
        className: "back-btn",
        "data-analytics-track": "".concat(stepName, "-back-btn"),
        kind: "secondary",
        onClick: function onClick() {
          return _this2.props.handleClick(prevIndex);
        }
      }, msgs.get("label.backButton")), wizardMode && showNext && /*#__PURE__*/React.createElement(Button, {
        className: "continue-btn",
        "data-analytics-track": "".concat(stepName, "-continue-btn"),
        kind: continueKind,
        onClick: function onClick() {
          return _this2.props.handleClick(nextIndex);
        }
      }, continueLabel), phase === Phase.PRE_CREATE && /*#__PURE__*/React.createElement(InlineLoading, {
        description: msgs.get("spinner.creating", locale)
      }), showCreate && phase !== Phase.PRE_CREATE && /*#__PURE__*/React.createElement(Button, _extends({
        className: "create-toolchain-btn"
      }, wizardMode ? {
        "data-analytics-success-flag": !isWizardInvalid
      } : {}, {
        "data-analytics-template": params.baseName,
        "data-analytics-track": wizardMode ? "wizard-create-btn-summary" : "setup-create",
        disabled: isCreateDisabled,
        onClick: function onClick() {
          fsCloudDialogData.showFSCloudDialog ? _this2.setState({
            showFSCloudComplianceDialog: true
          }) : _this2.props.handleDeployClicked();
        }
      }), wizardMode ? msgs.get("button.create.toolchain", locale) : msgs.get("button.create", locale)), /*#__PURE__*/React.createElement(FSCloudComplianceDialog, {
        accountTraitsError: fsCloudDialogData.accountTraitsError,
        lang: locale,
        modalOpen: this.state.showFSCloudComplianceDialog,
        onAccept: function onAccept() {
          _this2.setState({
            showFSCloudComplianceDialog: false
          });
          _this2.props.handleDeployClicked();
        },
        onClose: function onClose(evt) {
          return _this2.setState({
            showFSCloudComplianceDialog: false
          });
        }
      })));
    }
  }]);
}(React.Component);
export { DeployButtons as default };
DeployButtons.propTypes = {
  allowedRegion: PropTypes.bool,
  cancelHref: PropTypes.string,
  enableCreateButton: PropTypes.bool,
  envId: PropTypes.string.isRequired,
  handleDetailsClicked: PropTypes.func,
  handleDeployClicked: PropTypes.func,
  isWizardInvalid: PropTypes.bool,
  locale: PropTypes.string.isRequired,
  params: PropTypes.object,
  phase: PropTypes.string,
  enableToolchainCreateButton: PropTypes.bool,
  wizardMode: PropTypes.bool.isRequired
};